/*!
 * All material copyright ESRI, All Rights Reserved, unless otherwise specified.
 * See https://github.com/Esri/calcite-components/blob/master/LICENSE.md for details.
 * v1.0.0-beta.86
 */
function getRoundRobinIndex(n,e){return(n+e)%e}export{getRoundRobinIndex as g};